module.exports = __webpack_public_path__ + "img/33_62.a74eb7fc.png";